// extracted by mini-css-extract-plugin
module.exports = {"menu":"MobileMenu_menu__1r9jo","header":"MobileMenu_header__2M63_","title":"MobileMenu_title__BO2L4"};